import {
  OrderElementsQuestion,
  Column,
  Task,
  TaskStatus,
  OrderElementsActivityData,
} from '~/bootcamp/Activities/SanityActivities/OrderElements/types/OrderElements.types'

import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { BlockContent } from '~/bootcamp/Activities/types/activities.types'

const defaultCols: Column[] = [
  {
    id: 101,
    categoryName: 'question',
    position: 1,
  },
  {
    id: 102,
    categoryName: 'question',
    position: 2,
  },
  {
    id: 103,
    categoryName: 'question',
    position: 3,
  },
  {
    id: 104,
    categoryName: 'question',
    position: 4,
  },
  {
    id: 105,
    categoryName: 'question',
    position: 5,
  },
  {
    id: 106,
    categoryName: 'answer',
    position: 1,
  },
  {
    id: 107,
    categoryName: 'answer',
    position: 2,
  },
  {
    id: 108,
    categoryName: 'answer',
    position: 3,
  },
  {
    id: 109,
    categoryName: 'answer',
    position: 4,
  },
  {
    id: 110,
    categoryName: 'answer',
    position: 5,
  },
]

let defaultTasks: Task[] = []

export function sortData(arg: OrderElementsQuestion): void {
  const unshuffled = arg.elements.map((item: { element: BlockContent[] }, index: number) => {
    const data = {
      id: index + 1,
      position: index + 1,
      categoryName: 'question',
      content: {},
      check: false,
      taskStatus: TaskStatus.Unchecked,
    }

    data.content = item.element

    return data
  })

  // eslint-disable-next-line fp/no-mutating-methods
  defaultTasks = unshuffled
    .map((value: Task) => ({ value, sort: Math.random() }))
    .sort((a: { sort: number }, b: { sort: number }) => a.sort - b.sort)
    .map(({ value }: { value: Task }, index: number) => ((value.position = index + 1), value))
}

function getColumnsData(): Column[] {
  return defaultCols
}

function getTasksData(): Task[] {
  return defaultTasks
}

function generateOrderElementsActivityData(
  questions: OrderElementsQuestion[],
  history: number[],
): OrderElementsActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]

  return { question, questionIndex }
}
export { getColumnsData, getTasksData, generateOrderElementsActivityData }
